/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialV2ListItem
 */
export interface ProviderCredentialV2ListItem {
    /**
     * 
     * @type {string}
     * @memberof ProviderCredentialV2ListItem
     */
    id?: string;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof ProviderCredentialV2ListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof ProviderCredentialV2ListItem
     */
    provider?: GuidIdAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof ProviderCredentialV2ListItem
     */
    channel?: Int32IdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof ProviderCredentialV2ListItem
     */
    agency?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2ListItem
     */
    enabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialV2ListItem
     */
    allowEdit?: boolean;
}

export function ProviderCredentialV2ListItemFromJSON(json: any): ProviderCredentialV2ListItem {
    return ProviderCredentialV2ListItemFromJSONTyped(json, false);
}

export function ProviderCredentialV2ListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialV2ListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'provider': !exists(json, 'provider') ? undefined : GuidIdAndLabelFromJSON(json['provider']),
        'channel': !exists(json, 'channel') ? undefined : Int32IdAndLabelFromJSON(json['channel']),
        'agency': !exists(json, 'agency') ? undefined : GuidIdCodeAndLabelFromJSON(json['agency']),
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function ProviderCredentialV2ListItemToJSON(value?: ProviderCredentialV2ListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'provider': GuidIdAndLabelToJSON(value.provider),
        'channel': Int32IdAndLabelToJSON(value.channel),
        'agency': GuidIdCodeAndLabelToJSON(value.agency),
        'enabled': value.enabled,
        'allowEdit': value.allowEdit,
    };
}


